import { componentVariant } from '../../../internal/styles/componentVariant';

const sizeVariant = componentVariant({
  prop: 'size',
  variants: {
    small: {
      px: 'button.small.px',
      py: 'button.small.py',
      fontSize: 'headings.6',
      fontWeight: 'medium',
      lineHeight: 'headings.6',
    },
    medium: {
      px: 'button.medium.px',
      py: 'button.medium.py',
      fontSize: 'headings.5',
      fontWeight: 'medium',
      lineHeight: 'headings.5',
    },
    large: {
      px: 'button.large.px',
      py: 'button.large.py',
      fontSize: 'headings.4',
      fontWeight: 'medium',
      lineHeight: 'headings.5',
    },
  },
});

export default sizeVariant;
